import { useEffect } from "react";

const LoggedOut = () => {
    useEffect(() => {
      document.body.style.backgroundColor = "#fff";
    }, []);

  return (
    <div className="customErrorWrapper">
      
      <div className="goBackLink">
        <p>You have successfully logged out of the application.</p>
        <p>Please close this window.</p>
      </div>
    </div>
  );
};

export default LoggedOut;
